const DISTANCE = 60;
const DURATION = 600;

const map = new WeakMap();

const ob = new IntersectionObserver((entries) => {
  for (const entry of entries) {
    if (entry.isIntersecting) {
      const { animation, isDone } = map.get(entry.target);

      // 只有向下滚时出动画
      animation && isDone() && animation.play();
    }
  }
});

export default {
  mounted(el, bindings) {
    if (!bindings.value.start) return;

    const animation = el.animate(
      [
        {
          transform: `translateY(${DISTANCE}px)`,
          opacity: 0.5,
        },
        {
          transform: "translateY(0)",
          opacity: 1,
        },
      ],
      {
        duration: DURATION,
        ease: "ease-out",
        fill: "forwards",
      }
    );

    animation.pause();
    map.set(el, { animation, isDone: bindings.value.isDone });
    ob.observe(el);
  },
  unmounted(el) {
    ob.unobserve(el);
  },
};
